exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo[data-v-5c01489c]{align-items:center;display:flex\n}", ""]);

// exports
